import React, { createContext, useContext } from 'react'
import type { ReactNode } from 'react'
import type { MetricsClient } from '@strata-monorepo/metrics/lib/types/MetricsClient'
import { ConsoleAdapter } from '@strata-monorepo/metrics/lib/adapters/ConsoleAdapter'

// Default client for safety
const defaultClient: MetricsClient = new ConsoleAdapter()

const MetricsContext = createContext<MetricsClient>(defaultClient)

export const MetricsProvider: React.FC<{
  client?: MetricsClient
  children: ReactNode
}> = ({ client, children }) => {
  return (
    <MetricsContext.Provider value={client || defaultClient}>{children}</MetricsContext.Provider>
  )
}

export function useMetricsClient(): MetricsClient {
  return useContext(MetricsContext)
}
